import { render, staticRenderFns } from "./SpecialistStats.vue?vue&type=template&id=36cafc5a&scoped=true&"
import script from "./SpecialistStats.vue?vue&type=script&lang=js&"
export * from "./SpecialistStats.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistStats.vue?vue&type=style&index=0&id=36cafc5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cafc5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VAvatar,VCard,VCardActions,VCardTitle,VFlex,VIcon,VImg,VLayout,VRating})
